import { MainColor } from '../../../palette/colors';

export const getRadioItem = () => {
  return {
    defaultState: {
      svgColor: 'coolGrey60' satisfies MainColor as MainColor,
      color: 'navy95' satisfies MainColor as MainColor,
    },
    hover: {
      backgroundColor: 'navy10' satisfies MainColor as MainColor,
    },
    checked: {
      svgColor: 'navy60' satisfies MainColor as MainColor,
      backgroundColor: 'navy10' satisfies MainColor as MainColor,
    },
    disabled: {
      svgColor: 'coolGrey60' satisfies MainColor as MainColor,
      color: 'coolGrey60' satisfies MainColor as MainColor,
    },
  };
};

export type RadioItemTheme = ReturnType<typeof getRadioItem>;
